import {isLocalProfile, isRealProfile} from '@web/core/config'
import {createStore} from '@web/helpers/redux'
import {browserConfirm, browserEventEmitter} from '@web/middlewares/browserEventEmitter'
import {uiEventAction} from '@web/middlewares/uiLogging'

import {auth, orderInterruptedMiddleware, sessionSync, demo, maintenanceHandlerMiddleware} from './middleware'
import createRootReducer from './reducer'

const middlewares = [
    auth,
    maintenanceHandlerMiddleware,
    orderInterruptedMiddleware,
    browserEventEmitter,
    sessionSync,
    ...(!isRealProfile ? [demo] : []),
]

const store = createStore({
    rootReducerCreator: createRootReducer,
    middlewares: [...middlewares],
    defaultMiddlewareOptions: {
        serializableCheck: {
            ignoredActions: [uiEventAction.type, browserConfirm.type],
        },
    },
})

export default store

// eslint-disable-next-line @typescript-eslint/no-explicit-any
if (isLocalProfile && (module as any).hot) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ;(module as any).hot.accept('./reducer', () => store.replaceReducer(createRootReducer()))
}

export type {SyncState} from './middleware'
